var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.navClick}}),_c('v-toolbar-title',{staticClass:"pl-0 main-title",on:{"click":_vm.titleClick}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.subTitle))])]),_c('v-spacer'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }